<template>
  <router-link :to="{ name: 'leads.overview', params: { lead_id: lead.id } }">
    <div class="row">
      <div class="col-12 col-lg-3 flex-column align-items-stretch justify-content-center">
        <p class="text-truncate mb-1">
          <span class="strong">{{ lead.first_name }} {{ lead.surname }}</span>
        </p>
        <p class="text-truncate small text-muted mb-0">
          <template v-if="lead.company">{{ lead.company }}<br/></template>
          {{ lead.email }}
          <template v-if="lead.phone"><br/>{{ lead.phone }}</template>
          <template v-if="lead.mobile"><br/>{{ lead.mobile }}</template>
        </p>
      </div>
      <div class="col-12 col-lg">
        <pre class="lead-message mb-0">{{ lead.message }}</pre>
      </div>
      <div class="col-6 col-lg-auto lead-col-dates flex-column align-items-stretch justify-content-center">
        <p class="mb-0">
          <span class="data-label">Received</span>
          {{ lead.created_at | moment('DD/MM/YYYY') }}
        </p>
        <p class="mb-0">
          <span class="data-label">Updated</span>
          {{ lead.updated_at | moment('DD/MM/YYYY') }}
        </p>
      </div>
      <div class="col-6 col-lg-auto lead-col-status justify-content-lg-end">
        <div class="dropdown">
          <button
            type="button"
            class="btn btn-link p-0 dropdown-toggle"
            v-dropdown
            aria-haspopup="true"
            aria-expanded="false"
            @click.prevent
          >
            <span class="status" :class="statusClass">{{ lead.status }}</span>
          </button>
          <div class="dropdown-menu dropdown-menu-end">
            <a
              v-for="status in statuses"
              :key="status"
              class="dropdown-item"
              href="#"
              @click.prevent="updateStatus(status)"
            >{{ status }}</a>
          </div>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    lead: {
      required: true,
      type: Object
    }
  },

  data () {
    return {
      statuses: ['New', 'Contacted', 'Closed', 'Spam']
    }
  },

  computed: {
    statusClass () {
      return {
        New: 'status-primary',
        Contacted: 'status-info',
        Closed: 'status-success',
        Spam: 'status-danger'
      }[this.lead.status] || ''
    }
  },

  methods: {
    ...mapActions('lead', { updateLead: 'updateListObject' }),

    async updateStatus (status) {
      await this.updateLead({ id: this.lead.id, payload: { status } })

      this.$emit('status-changed', this.lead)
    }
  }
}
</script>

<style scoped>
.lead-message {
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  padding: 0.5rem 0.75rem;
  font-family: inherit;
  font-size: 0.875rem;
  white-space: pre-wrap;
  word-break: break-word;
  background-color: var(--bs-tertiary-bg, #f8f9fa);
  border-radius: var(--bs-border-radius, 0.375rem);
}
</style>
